export const faqContractors = [
  {
    section: "Getting Started",
    items: [
      { q: "How do I join Mapeach?", a: "Apply through our website or by referral. After approval, we’ll help you onboard." },
      { q: "Can I choose which projects I work on?", a: "Yes, you’ll be matched to opportunities that fit your skills." },
      { q: "Can I work from home?", a: "Yes, 100% remote unless a client requests otherwise." },
      { q: "Will the client interview me?", a: "Usually yes, before final selection." },
    ]
  },
  {
    section: "Contracts & Legal",
    items: [
      { q: "What contract do I sign?", a: "An contract agreement with Client / Mapeach covering NDAs, IP rights, project details." },
      { q: "Can I review before signing?", a: "Absolutely — you can ask questions or clarifications." },
      { q: "Can I freelance elsewhere?", a: "Yes, as long as there’s no conflict with your active project." },
      { q: "What if I resign?", a: "Just follow your notice period — we’ll handle offboarding properly." },
      { q: "Do I sign NDAs?", a: "Yes, protecting client data and confidentiality." },
      { q: "Who owns the IP I create?", a: "Your client — Mapeach ensures this is legally documented." },
      { q: "Can I extend my contract?", a: "Yes, based on client and project needs." },
      { q: "Are contracts digital?", a: "Yes, we use secure e-signature platforms." }
    ]
  },
  {
    section: "Payments & Taxes",
    items: [
      { q: "How am I paid?", a: "Monthly or Bi- Weekly, directly to your bank by Mapeach." },
      { q: "When do I get paid?", a: "Usually on the last working day of each month." },
      { q: "Are taxes deducted?", a: "Yes, TDS and statutory deductions are managed for you." },
      { q: "Do I get payslips?", a: "Yes, every month electronically." },
      { q: "Can I claim expenses?", a: "Yes, if pre-approved by your client." },
      { q: "Can I get bonuses?", a: "Yes, if defined in your contract." },
    ]
  },
  {
    section: "Work & Culture",
    items: [
      { q: "Who do I report to?", a: "Your client’s manager." },
      { q: "Can I work flexible hours?", a: "Yes, depending on your client’s time zone." },
      { q: "Do I get equipment?", a: "Sometimes from clients; otherwise you use your own." },
      { q: "Can I take leave?", a: "Yes, as per your contract and client policy." },
      { q: "Which holidays apply?", a: "Usually the client’s holiday calendar." },
    ]
  }
];


